import LinksContent from "../components/LinksContent";

const Links = () => {
  return <LinksContent />
};

export default Links;
